import {
  c2s
} from '../../../deps/utils'

const xhr = ({
  method = 'post',
  url,
  forceMock = false,
  mask = true,
  callbackCoverServer = true,
  silentError = false,
  ajaxType = null,
  header = null,
  body = null,
  params=null,
  loadingMessage = null
}) => {
  // debugger // eslint-disable-line
  return c2s({
    ignoreMock: true,
    method,
    url: url,
    data: {
      header: { ...(header || {}) },
      body: { ...(body || {}) }
    },
    onSuccess: ({ body }) => new Promise((resolve) => {
      resolve(body)
    }),
    onError: (error) => new Promise((resolve, reject) => {
      reject(error)
    }).catch(() => {
      return false
    }),
    onCallback: (callback) => new Promise((resolve) => {
      resolve(callback)
    })
  }, {
    mask,
    ajaxType: ajaxType || 'ignore',
    forceMock,
    callbackCoverServer,
    loadingMessage,
    params,
    silentError: (result) => {
      let { data } = result.response || {
        data: {
          header: {}
        }
      }
      data = data || {
        header: {}
      }
      if (data.header && data.header.code === '300000000009') {
        location.href = '/login'
        return true
      }
      return silentError
    }
  })
}

export default xhr
